"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const FormButtonAnimation = (0, _styledComponents.keyframes)`
  0%   { transform: translateY(50px); }
  100% { transform: translateY(0px); }
`;
const StyledStickyFooter = _styledComponents.default.div`
  ${({
  sticky,
  theme
}) => (0, _styledComponents.css)`
    ${sticky && (0, _styledComponents.css)`
      animation: ${FormButtonAnimation} 0.25s ease;
      position: sticky;
      width: 100%;
      bottom: 0;
      left: 0;
      background-color: ${theme.colors.white};
      box-shadow: 0 -4px 12px rgba(153, 173, 182, 0.05);
      z-index: 1000;
    `}
  `}
`;
StyledStickyFooter.defaultProps = {
  theme: _base.default
};
var _default = StyledStickyFooter;
exports.default = _default;